import { useEffect, useState, type ReactNode } from "react";

import { useInsurancesListQuery } from "~/services";
import { INSURANCE_NOT_FOUND_OPTION } from "~/shared.types";
import { Dropdown, Option } from "~/ui";

interface InsuranceDropdownProps {
  value?: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  stateId: number | null;
  eligibility?: string[];
  error?: string;
  description?: ReactNode;
  onClose?: () => void;
}

export const InsuranceDropdown = ({
  value,
  onChange,
  disabled = false,
  stateId,
  eligibility,
  error,
  description,
  onClose,
}: InsuranceDropdownProps) => {
  const [options, setOptions] = useState<Option<number>[]>([]);

  const { data: insurances } = useInsurancesListQuery({
    stateId,
    eligibility,
  });

  useEffect(() => {
    if (insurances) {
      const options: Option<number>[] = insurances
        ?.filter((insurance) => !!insurance?.id)
        .map((insurance) => ({
          value: insurance.id,
          label: insurance.name,
        }));
      options.push(INSURANCE_NOT_FOUND_OPTION);

      setOptions(options);
    }
  }, [insurances]);

  return (
    <Dropdown
      options={options}
      value={value ?? undefined}
      placeholder="Please select"
      label="Insurance"
      disabled={disabled}
      onChange={onChange}
      error={error}
      description={description}
      onClose={onClose}
    />
  );
};
